export const PageInstructions = [
    {
        title: 'Great news! We have advisers who can help with that',
        subtitle: 'Simply fill in the form below to have a free, no obligation conversation with a top rated ' +
            'adviser near you; we will find the best highly rated local advisers for your situation.',
    },
    {
        title: 'Thanks! Your request is almost complete',
        subtitle: 'It\'s important you <span class="bold">edit</span> and <span class="bold">add' +
        ' info</span> to your message below (the more detail the better e.g. specific needs and the best time ' +
        'to contact you). ' +
        'Then click \'Send\' and we will send it to the best mortgage adviser for your situation.',
    },
    {},
];

export const PageTitles = ['', '', ''];

export const DEFAULT_TITLE = '';



// WEBPACK FOOTER //
// ./src/content/StepContent.js